import apiService from '@/services/apiService';

const actions = {
  getAllClick2Buy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-market/click-to-buy/find-with-paging',payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAllClick2BuyNew({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxel-market/click-to-buy?status=${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAllMerchant({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-market/merchant/find-all',payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postClick2Buy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-market/click-to-buy',payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  editClick2Buy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-market/click-to-buy/${payload.id}`,payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  ChangeStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-market/click-to-buy/update-status',payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  infoShowing({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-market/click-to-buy/showing-data-information')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getProductByMerchantID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxel-market/merchant/products-by-merchant-id/${payload.id}&limit=${payload.limit}&page=${payload.page}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getProductDetailByID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxel-market/merchant/product-detail-by-id/${payload.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getClick2BuyByID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxel-market/click-to-buy/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAdminhub({ commit }) {
    apiService.setHeader();
    apiService.get('additional-info/admin-hub')
      .then((response) => {
        commit('getAdminhub', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getPackageSize({ commit }) {
    apiService.get('additional-info/package-size')
      .then((response) => {
        commit('getPackageSize', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateStatusArticles({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('article/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderArticle({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`article/${payload.id}/change-order-category`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  ChangeOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`paxel-market/click-to-buy/change-order`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delClick2buy({ commit }, payload) {
    apiService.delete(`paxel-market/click-to-buy/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default actions;
